export default {
  screens: [
    {
      type: 'intro',
      title: '約瑟芬',
      content:
        '約瑟芬，Chaumet世家的繆斯女神自1805年選擇Chaumet作爲御用珠寶商開始，約瑟芬皇后便成了品牌源源不斷的靈感泉源。 ',
      idYt: 'gQZPa0SdueQ',
      videoCover: 'world/josephine/video.jpg',
      desktop: {
        cover: 'world/josephine/cover-1.jpg'
      },
      mobile: {
        cover: 'world/josephine/mobile-cover-1.jpg',
        contentStyle: { width: '95%' },
        titleStyle: { width: '60%' },
        coverStyle: {
          width: 'auto',
          width: '50%',
          bottom: '0',
          right: '0',
          left: 'inherit',
          position: 'absolute'
        }
      }
    },
    {
      type: 'memento',
      img: 'world/josephine/memento.jpg',
      content:
        '約瑟芬出生於植物繁茂的馬提尼克，一生中對繽紛鮮豔的異國情調一直情有獨鍾。<br/><br/> 她在藝術、時尚、裝飾品和植物的奢華品味，成了其時代潮流的先驅。',
      cover: 'world/josephine/cover-2.jpg'
    },
    {
      type: 'shadow',
      desktop: {
        middleImg: 'home/world/josephine.jpg',
        leftImg: 'world/josephine/shadowLeft.jpg',
        cover: 'world/josephine/cover-3.jpg'
      },
      mobile: {
        middleImg: 'home/world/josephine.jpg',
        leftImg: 'world/josephine/shadowLeft.jpg',
        cover: 'world/josephine/mobile-cover-3.jpg',
        coverStyle: {
          width: '62%',
          top: '41%',
          left: '-19%',
          right: 'inherit',
          position: 'absolute'
        }
      },
      content:
        'Chaumet設計珠寶不斷從約瑟芬風格的藝術中汲取靈感，約瑟芬同名系列珠寶孕育而生，皇冠鑽冕幻化成戒指。'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/locales/cht/worlds/josephine.js